import { FilterSearch } from '../filter-search.model';

export class CarrierListFilters {
  public static filterSearch: FilterSearch = {
    filterSearchValue: '',
  };
}
